import { format } from "date-fns";

function getLang() {
  if (navigator.languages != undefined) return navigator.languages[0];
  else return navigator.language;
}

export default {
  bytes(bytes) {
    if (!bytes) return "0 B";
    const power = Math.floor(Math.log(bytes) / Math.log(1024));
    const unit = ["B", "KB", "MB", "GB"][power];
    return `${(bytes / 1024 ** power).toFixed(1)} ${unit}`;
  },

  capitalize(text) {
    if (!text) return "";
    return text[0].toUpperCase() + text.substr(1);
  },

  capitalizeAll(text) {
    return text.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
  },

  currency(s) {
    s = s || 0;
    return new Intl.NumberFormat(getLang(), {
      style: "currency",
      currency: "USD"
    }).format(s);
  },

  phone(num) {
    if (!num) return "";

    const phone = num.substring(0, 10); // First ten digits of output only
    const zip = num.substring(0, 3);
    const middle = num.substring(3, 6);
    const last = num.substring(6, 10);

    if (phone.length > 6) {
      return `(${zip}) ${middle}-${last}`;
    } else if (phone.length > 3) {
      return `(${zip}) ${middle}`;
    } else if (phone.length > 0) {
      return `(${zip}`;
    }
  },

  date(input, returnedFormat = "D MMM, YYYY") {
    return format(input, returnedFormat);
  },

  pluralize(num, text, ending = "s") {
    text = num + " " + text;
    return num === 1 ? text : text + ending;
  }
};
